import React from 'react';

const ContactUsError: React.FC<{}> = () => {

    return <section
        id='thanks'
        role='contentinfo'
        aria-label='Error processing your request'>

            <p>
                <strong>Thank you for contacting Center for the Study of Services.</strong>
            </p>

            <p>There was an error processing to your request. Please check back with us later.</p>

            <p>
                <a href='/'>return to home page</a>
            </p>

        </section>;
}

export default ContactUsError;